import BaseService from "./base-service";

export default class UserService extends BaseService {

    constructor() {
        super('users');
    }
}
